import { getCapacitorPushPlugin } from './driverPush';

/**
 * The channel for notices about the person's own account (InGo ADR 0038):
 * today "Your account will be deleted on …", sent by the server as a plain
 * notification Android draws itself, so no app code runs for it
 * (background-push rule 1). A client's and a rider's alike.
 *
 * MUST equal `DeletionWarning::CHANNEL_ID` in InGo's backend
 * (`Modules/Push/Messages/DeletionWarning.php`): a push naming a channel the
 * app never created lands on FCM's fallback channel (rule 5).
 * `driverPushChannel.test.js` reads both.
 */
export const ACCOUNT_CHANNEL_ID = 'ingo_account';

let channelReady = false;

/**
 * Create the channel. Ordinary importance (3, IMPORTANCE_DEFAULT): a sound,
 * no heads-up, no full-screen intent, never through Do Not Disturb (rule 9).
 * It is a notice, not a job. No-op on the web; safe to call again.
 *
 * @param {any} [Push] the Capacitor push plugin, for tests
 */
export async function ensureAccountChannel(Push) {
  if (channelReady) return;
  const plugin = Push || (await getCapacitorPushPlugin());
  if (typeof plugin?.createChannel !== 'function') return;
  try {
    // No `sound` key: Capacitor would point it at res/raw/<value> (driverPush.js).
    await plugin.createChannel({
      id: ACCOUNT_CHANNEL_ID,
      name: 'Your account',
      description: 'Notices about your InGo account, such as a deletion you asked for.',
      importance: 3,
    });
    channelReady = true;
    console.info(`[accountChannel] channel ready ${ACCOUNT_CHANNEL_ID}`);
  } catch (e) {
    console.warn(`[accountChannel] channel not created: ${e?.message || e}`);
  }
}
